import { useTranslation } from 'react-i18next';
import QuestionContainer from '../QuestionContainer';
import {
  QuestionInput,
  QuestionInputContainer,
  QuestionInputHalfHeight,
  QuestionSubHeading,
  QuestionTextarea,
  QuestionTextareaContainer,
} from './TextQuestion.styles';
import * as React from 'react';
import type { TranslationKey } from 'src/types';

interface Props {
  organisation: string;
  textFieldValue: string;
  i18nHeader: TranslationKey;
  i18nDescription: TranslationKey;
  i18nPlaceholder: TranslationKey;
  backLink: string;
  nextLink: string;
  percentage: number;
  requireAnswer?: boolean;
  setQuestionData(text: string): void;
}

export const TextQuestion: React.FC<Props> = (props) => {
  const [text, setText] = React.useState(props.textFieldValue);
  return (
    <QuestionContainer
      organisation={props.organisation}
      backLink={props.backLink}
      nextLink={props.nextLink}
      requireAnswer={props.requireAnswer}
      submitAnswer={() => {
        props.setQuestionData(text);
      }}
      textFieldValue={text}
      i18nHeader={props.i18nHeader}
      percentage={props.percentage}
    >
      <TextQuestionContent
        organisation={props.organisation}
        textFieldValue={text}
        i18nDescription={props.i18nDescription}
        i18nPlaceholder={props.i18nPlaceholder}
        setQuestionData={setText}
      />
    </QuestionContainer>
  );
};

interface TextQuestionContentProps {
  organisation: string;
  textFieldValue: string;
  i18nDescription: TranslationKey;
  i18nPlaceholder: TranslationKey;
  setQuestionData(text: string): void;
}

export const TextQuestionContent: React.FC<TextQuestionContentProps> = (
  props,
) => {
  const { t } = useTranslation();
  const [showTextArea, setShowTextArea] = React.useState(
    props.textFieldValue !== '',
  );

  return (
    <>
      {showTextArea ? (
        <QuestionTextareaContainer>
          <QuestionSubHeading>{t(props.i18nDescription)}</QuestionSubHeading>
          <QuestionTextarea
            data-testid="text-question-textbox"
            autoFocus
            onChange={(
              event:
                | React.FormEvent<HTMLTextAreaElement>
                | React.ChangeEvent<HTMLInputElement>,
            ) => props.setQuestionData(event.currentTarget.value)}
            value={props.textFieldValue}
            placeholder={t(props.i18nPlaceholder)}
          />
        </QuestionTextareaContainer>
      ) : (
        <QuestionInputContainer>
          <QuestionInputHalfHeight>
            <QuestionSubHeading>{t(props.i18nDescription)}</QuestionSubHeading>
            <QuestionInput
              data-testid="text-question-input"
              placeholder={t(props.i18nPlaceholder)}
              onClick={() => setShowTextArea(true)}
            />
          </QuestionInputHalfHeight>
        </QuestionInputContainer>
      )}
    </>
  );
};

export default TextQuestion;
